// Re-export shared error constants so legacy imports work without change.
export { ErrorCode, ERROR_MESSAGES } from '@fitted/error-codes';

// For compatibility the front-end expects HTTP_ERROR_MAPPING. Build a thin helper
// from the shared message map (generic mapping used only for non-JSON responses).
import { HTTP_STATUS_TO_ERROR, ErrorCode, ERROR_MESSAGES } from '@fitted/error-codes';

// Helper to extract best-effort user-friendly message from arbitrary error value
export const getErrorMessage = (err: any): string => {
  if (err instanceof Error) return err.message;
  if (typeof err === 'string') return err;
  if (err && typeof err === 'object') return err.message || JSON.stringify(err);
  return ERROR_MESSAGES[ErrorCode.UNKNOWN_ERROR];
};

export const HTTP_ERROR_MAPPING = Object.fromEntries(
  Object.entries(HTTP_STATUS_TO_ERROR).map(([status, code]) => [status, ERROR_MESSAGES[code as ErrorCode] || 'Something went wrong. Please try again.'])
) as Record<number, string>;
